var map = {
	"./1.jpg": 89849,
	"./10.jpg": 65605,
	"./11.jpg": 22088,
	"./12.jpg": 6839,
	"./13.jpg": 43002,
	"./2.jpg": 91182,
	"./3.jpg": 70667,
	"./4.jpg": 67064,
	"./5.jpg": 28245,
	"./6.jpg": 4106,
	"./7.jpg": 99911,
	"./8.jpg": 52436,
	"./9.jpg": 66161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78541;